export function populateRateSetDropdown(soldAsDataArray) {
  const soldAsDropdowns = document.querySelectorAll(
    '#addTourForm [name=rate_set], #addAccommodationForm [name=rate_set]',
  );

  // Convert NodeList to Array and iterate over each dropdown
  Array.from(soldAsDropdowns).forEach((soldAsDropdown) => {
    // Clear existing options for the current dropdown
    soldAsDropdown.innerHTML = '';

    // Populate options for the current dropdown
    soldAsDataArray.forEach((data) => {
      let option = document.createElement('option');
      option.value = data.id;
      // Add star symbol for packages
      option.textContent = data.is_package
        ? `★ ${data.public_name}`
        : data.public_name;
      soldAsDropdown.appendChild(option);
    });
  });
}
